import React from "react";
import { BriefcaseBusiness, Plus } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./Vacancies.scss";
import { photoVariant } from "../../../../utils/imageUrl";

export default function Vacancies({ vacancies = [], onAddVacancy, ownerId }) {
  const navigate = useNavigate();

  // Hidden items are only actionable from the full management list — this
  // is just a quick teaser rail, so keep it limited to what's visible now.
  const visibleVacancies = Array.isArray(vacancies)
    ? vacancies.filter((v) => (v.status || "active") !== "hidden")
    : [];
  const hasVacancies = visibleVacancies.length > 0;
  const previewVacancies = hasVacancies ? visibleVacancies.slice(0, 5) : [];

  const openAllVacancies = () => {
    if (ownerId) {
      navigate(`/profile/${encodeURIComponent(ownerId)}/vacancies`);
      return;
    }

    navigate("/business/vacancies");
  };

  const formatSalary = (item) => {
    const from = Number(item.salaryFrom || item.price || 0);
    const to = Number(item.salaryTo || 0);
    const currency = item.currency || "ГРН";

    if (from > 0 && to > 0) return `${from}–${to} ${currency}`;
    if (from > 0) return `від ${from} ${currency}`;
    return "Зарплата за домовленістю";
  };

  const formatMeta = (item) => {
    const parts = [
      item.workFormat,
      item.employmentType,
      item.experience,
    ].filter(Boolean);

    return parts.length ? parts.join(" · ") : "Деталі не вказані";
  };

  return (
    <div className="bpVacancies">
      {!hasVacancies ? (
        <div className="bpVacancies__empty">
          <div className="bpVacancies__emptyIcon">
            <BriefcaseBusiness size={30} strokeWidth={2.4} />
          </div>

          <strong>Вакансій поки немає</strong>

          <p>
            Додай першу вакансію. Вона зʼявиться у бізнес-профілі, стрічці та пошуку.
          </p>

          <button type="button" onClick={onAddVacancy}>
            <Plus size={19} strokeWidth={2.8} />
            Додати вакансію
          </button>
        </div>
      ) : (
        <>
          <div className="bpVacancies__top">
            <div>
              <strong>{vacancies.length} вакансій</strong>
              <span>Перші вакансії у превʼю блоку</span>
            </div>

            <button type="button" onClick={openAllVacancies}>
              Усі вакансії
            </button>
          </div>

          <div className="bpVacancies__grid">
            {previewVacancies.map((item) => {
              const photo = item.mainPhoto || item.photos?.[0] || "";

              return (
                <article
                  key={item.listingId || item.id}
                  className="bpVacancyCard"
                  onClick={() => navigate(`/listing/${item.listingId}`)}
                >
                  <div className="bpVacancyCard__image">
                    {photo ? (
                      <img src={photoVariant(photo, "sm")} alt="" loading="lazy" decoding="async" />
                    ) : (
                      <span>💼</span>
                    )}

                    <em>Вакансія</em>
                  </div>

                  <div className="bpVacancyCard__body">
                    <strong>{item.title || "Нова вакансія"}</strong>
                    <p>{formatMeta(item)}</p>

                    <div>
                      <b>{formatSalary(item)}</b>
                      <button type="button">Відкрити</button>
                    </div>
                  </div>
                </article>
              );
            })}

            <button
              type="button"
              className="bpVacancyAddCard"
              onClick={onAddVacancy}
            >
              <span>
                <Plus size={23} strokeWidth={2.8} />
              </span>
              <strong>Додати вакансію</strong>
              <em>Опис, зарплата, формат</em>
            </button>
          </div>
        </>
      )}
    </div>
  );
}